import { useNavigate } from 'react-router-dom'
import utility from 'src/utils/utility'
import {
    Header, Card, Button, IconCircle, Text, Box, Flex, tokens,
} from 'src/componentv2'

import qoreIcon from 'src/assets/v2/img/qore_icon.svg'
import checkBigSuccess from 'src/assets/v2/img/check_big_success_icon.svg'

const SetupSuccess = () => {
    const navigate = useNavigate()

    return (
        <Box bgColor={tokens.pageBg} minHeight="100vh">
            <Header logo={<img src={qoreIcon} alt="Qore" />} initials="QO" />

            <Flex justify="center" items="flex-start" padding="3.2">
                <Card
                    width="56" maxWidth="100%" radius="1.2" padding="4"
                    topMargin="6" fluidOn={560}
                >
                    <Flex direction="column" items="center">
                        <IconCircle size="9" bgColor="#D1FADF">
                            <img src={checkBigSuccess} alt="" />
                        </IconCircle>

                        <Text topMargin="2.4" fontSize="2.6" fontWeight="700" align="center">
                            You're All Set! 🎉
                        </Text>
                        <Text topMargin="1" fontSize="1.5" color={tokens.textMuted} align="center">
                            Congratulations! Your setup is complete and you can now access your dashboard
                        </Text>

                        <Box topMargin="2.4">
                            <Button
                                variant="primary" size="md"
                                icon={<span style={{ fontSize: '1.6rem' }}>→</span>}
                                iconPosition="right"
                                onClick={() => navigate('/dashboardv2/profile')}
                            >
                                Go to Dashboard
                            </Button>
                        </Box>
                    </Flex>
                </Card>
            </Flex>
        </Box>
    )
}

export default utility.routeData('setup-success', 'Setup Complete', <SetupSuccess />)